import React from 'react';
import PropTypes from 'prop-types';

import { ID } from 'utilz';

import './styles.scss';

const CheckableInput = ({
  name, isRadio, children, value, changeHandl, disabled, checked
}) => {
  const generatedId = ID();
  const renderChecked = () => {
    const obj = {};
    obj.checked = checked;

    return obj;
  };
  return (
    <div className={`checkable-input ${isRadio ? '-radio' : '-checkbox'} ${disabled ? '-disabled' : ''} ${checked ? '-checked' : ''}`}>
      <input
        id={generatedId}
        name={name}
        type={isRadio ? 'radio' : 'checkbox'}
        value={value}
        onChange={changeHandl}
        {...renderChecked()}
      />
      <label htmlFor={generatedId}>{children}</label>
    </div>
  );
};

CheckableInput.defaultProps = {
  isRadio: true,
  disabled: false,
  checked: false
};

CheckableInput.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  isRadio: PropTypes.bool,
  changeHandl: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  checked: PropTypes.bool
};

export default CheckableInput;



// WEBPACK FOOTER //
// ./src/components/CheckableInput/index.js